import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../themes/palette"

const useStyles = makeStyles((theme) => ({
	root: {
		height: "100vh",
	},
	mainGrid:{
		margin:'auto',
		justifyContent:'center',
		[theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
			width: 600,
			marginLeft: "auto",
			marginRight: "auto",
		},
		marginTop:175,
		[theme.breakpoints.down(myTheme.breakpoints.values.xmd)]: {
		  marginTop:164,
		},
		[theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
		  marginTop:160,
		},
	},
	paper: {
		margin: theme.spacing(7, 4),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: myTheme.palette.primary.main,
	},
	form: {
		width: "100%", // Fix IE 11 issue.
		marginTop: theme.spacing(3),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
}));

export default useStyles;
